module.exports = __webpack_public_path__ + "static/media/google-play-badge.05d2752e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/google-play-badge.png
// module id = 583
// module chunks = 11